import { useTranslation } from "react-i18next";
import { CalendarCheckIcon } from "@phosphor-icons/react";
import type { ServiceInfo } from "./types";
import type { PaymentMethodId } from "./PaymentStep";
import { AppointmentTicket, fmtKm, ticketPriceLabel } from "./AppointmentTicket";

export function ConfirmStep({
	service, date, time, paymentMethod,
	companyPayment, chargeAmount, modality, officeAddress,
}: {
	service: ServiceInfo;
	date: Date;
	time: string;
	paymentMethod: PaymentMethodId;
	companyPayment?: { companyName: string; chargeAmount: number } | null;
	/** Server quote for card / bank transfer; ignored for company credit. */
	chargeAmount?: number | null;
	modality: "online" | "in_person";
	officeAddress?: string | null;
}) {
	const { t } = useTranslation();
	const isCompanyCredit = paymentMethod === "company_credit";
	const methodLabel =
		paymentMethod === "monri"
			? t("booking.payCard")
			: paymentMethod === "bank_transfer"
				? t("booking.payTransfer")
				: t("booking.payCompany");

	const priceLabel = ticketPriceLabel({ service, paymentMethod, companyPayment, chargeAmount });

	const companyLine =
		companyPayment
			? t("booking.payCompanyConfirmLine", {
					companyName: companyPayment.companyName,
					amount: fmtKm(companyPayment.chargeAmount),
				})
			: null;

	return (
		<div className="flex flex-col gap-4">
			<div className="flex items-center gap-2.5">
				<div className="flex size-9 shrink-0 items-center justify-center rounded-xl"
				     style={{ background: "oklch(37.12% 0.059 186.62 / 0.12)" }}>
					<CalendarCheckIcon className="size-[18px]" weight="bold"
					                   style={{ color: "oklch(37.12% 0.059 186.62)" }} />
				</div>
				<p className="text-[15px] font-semibold text-foreground"
				   style={{ fontFamily: "var(--font-heading)" }}>
					{t("booking.confirmTitle")}
				</p>
			</div>

			<AppointmentTicket
				service={service}
				date={date}
				time={time}
				methodLabel={methodLabel}
				priceLabel={priceLabel}
				companyLine={companyLine}
				chargeAmount={isCompanyCredit ? null : chargeAmount}
				modality={modality}
				officeAddress={officeAddress}
			/>
		</div>
	);
}
